'use client';
import { Box, Flex, Icon } from '@chakra-ui/react';
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { AiFillCamera } from 'react-icons/ai';
import { useDeliveryInfo } from '~/hooks/resources/delivery_info';
import { apiClient } from '~/lib/apiClient';
import { RootContext } from '~/store';
import { Avatar } from '../ui/avatar';
import { toaster } from '../ui/toaster';

const CircleIcon = () => (
  <Box
    borderRadius="full"
    bg="white"
    p="2px"
    zIndex="2"
    flex-shrink="0"
    width="27px"
    height="27px"
    display="flex"
    line-height="1em"
  >
    <Icon as={AiFillCamera} fontSize="23px" color="black" />
  </Box>
);

type Props = {
  url?: string;
  load: boolean;
  submitting: boolean;
};

export const ProfileImageForm: React.FC<Props> = (props: Props) => {
  const { token } = useContext(RootContext);
  const [image, setImage] = useState<string | null>(null);
  const { mutate } = useDeliveryInfo();
  const [, setSubmitting] = useState(props.submitting);
  const inputRef = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (props.url != null) {
      setImage(props.url);
    } else {
      setImage(null);
    }
    inputRef.current?.focus();
  }, [props.url]);

  const refCheck = (): void => {
    if (inputRef.current == null) {
      console.log('current:' + inputRef.current);
    } else {
      console.log('current:' + inputRef.current);
    }
  };

  const handleClick = () => {
    refCheck();
    inputRef.current?.click();
  };

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (file instanceof File) {
      const allowedTypes = ['image/png', 'image/jpeg'];

      if (!allowedTypes.includes(file.type)) {
        alert('PNGまたはJPEG形式のファイルを選択してください');
        return;
      }

      const image_url = await uploadImage(file);
      if (image_url != null) {
        const handleSubmit = async () => {
          setSubmitting(true);
          try {
            const patch_res = await apiClient.v1.me.infos.patch({
              headers: {
                Authorization: `Bearer ${token?.token}`,
              },
              body: {
                icon_image_url: image_url,
              },
            });
            if (patch_res.status === 204) {
              mutate();
              setSubmitting(false);
              toaster.success({
                title: 'プロフィール画像を登録しました',
                duration: 2000,
              });
            } else {
              {
                async () => console.log('error');
              }
              setSubmitting(false);
            }
          } catch (e) {
            console.log(e);
          }
        };
        handleSubmit();
      }
    }
  };

  const uploadImage = async (image_file: File) => {
    const pre_signed_url = await getPresignedPostUrl(image_file.name);

    if (typeof pre_signed_url === 'string') {
      const upload_res = await axios.put(pre_signed_url, image_file, {
        headers: {
          ContentType: image_file.type,
        },
      });
      const image_url = upload_res.request.responseURL.split('?')[0];
      setImage(image_url);
      return image_url;
    }
  };

  const getPresignedPostUrl = async (image_name): Promise<string> => {
    const extension = image_name.substring(image_name.lastIndexOf('.') + 1);

    const pre_signed_res = await apiClient.v1.me.icons.upload.post({
      headers: {
        Authorization: `Bearer ${token?.token}`,
      },
      body: {
        extension_type: extension,
      },
    });
    return pre_signed_res.body.presigned_url;
  };

  return (
    <Flex justifyContent="center" alignItems="center" position="relative">
      <Box w="100px" h="100px" overflow="hidden" position="relative">
        <Box
          w="100px"
          h="100px"
          overflow="hidden"
          position="relative"
          borderWidth="1px"
          borderColor="#A0A3A6"
          borderRadius="full"
        >
          <Avatar
            src={image ?? ''}
            style={{ clipPath: 'circle(50% at 50% 50%)' }}
            objectFit="cover"
            w="100%"
            h="100%"
          />
        </Box>
        <Box
          display="flex"
          webkit-box-align="center"
          webkit-box-pack="center"
          justify-content="center"
          align-items="center"
          position="absolute"
          bottom="0px"
          right="0px"
          borderRadius="full"
          cursor="pointer"
          onClick={handleClick}
          zIndex="1"
          borderWidth="1px"
          borderColor="black"
        >
          <input
            type="file"
            autoComplete="cc-name"
            ref={inputRef}
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />
          <CircleIcon />
        </Box>
      </Box>
    </Flex>
  );
};

export default ProfileImageForm;
